import { createAction } from "redux-actions";
import {
	createSystem,
	getForm,
	getFormResult,
	getSystem,
	saveFormResult,
	updateSystem,
} from "../../services/system";

export enum ACTIONS {
	CREATE = "CREATE_SYSTEM/CREATE",
	UPDATE = "CREATE_SYSTEM/UPDATE",
	GET = "CREATE_SYSTEM/GET",
	RESET = "CREATE_SYSTEM/RESET",
	LOAD_FORM = "CREATE_SYSTEM/LOAD_FORM",
	GET_FORM_RESULT = "CREATE_SYSTEM/GET_FORM_RESULT",
	SUBMIT_FORM_RESULT = "CREATE_SYSTEM/SUBMIT_FORM_RESULT",
}

export const create = createAction(ACTIONS.CREATE, createSystem);
export const update = createAction(ACTIONS.UPDATE, updateSystem);
export const get = createAction(ACTIONS.GET, getSystem);
export const reset = createAction(ACTIONS.RESET);
export const loadForm = createAction(ACTIONS.LOAD_FORM, getForm);
export const loadFormResult = createAction(
	ACTIONS.GET_FORM_RESULT,
	getFormResult
);
export const submitFormResult = createAction(
	ACTIONS.SUBMIT_FORM_RESULT,
	saveFormResult
);
